import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('meioAmbienteClasses');

export const check = () => useBasicAuth.checkToken();

export const findMeioAmbienteClasseById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllMeioAmbienteClasse = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllMeioAmbienteClasseByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllMeioAmbienteClasseByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });


export const addMeioAmbienteClasse = (obj) => 
  axios.post(urlAPI, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateMeioAmbienteClasse = (obj) => 
  axios.put(urlAPI + "/" + obj.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteMeioAmbienteClasse = (id) => 
  axios.delete(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });